// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"54a2fb8e","539":"578100ca"}[chunkId] + ".chunk.js";
};